/* eslint-disable prefer-template */
/* eslint-disable camelcase */
import axios from 'axios';
import axiosRetry from 'axios-retry';
import uuid from '../uuid';
import { getRequestHeaders } from './request-headers';
import { accessToken, getCvAccessToken } from '@carvana/purchase-helpers';
import Cookies from 'js-cookie';

const { CancelToken } = axios;
export const CancelAxios = CancelToken.source();

const tokenRefreshUrl = `${process.env.BASE_URL}${process.env.CVNA_APP_AUTH_TOKEN}`;

const axiosInstance = axios.create({
  baseURL: process.env.BASE_URL,
  maxRedirects: 0,
  headers: getRequestHeaders()
});

axiosRetry(axiosInstance, {
  retries: 0,
  retryDelay: retryCount => retryCount * 1000
});

const fetchAuthToken = () =>
  axiosInstance
    .post(tokenRefreshUrl, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      return res.data;
    })
    .catch(async error => {
      const { response: { status = null } = {} } = error;
      const isStatusFourHundred = status >= 400;

      if (isStatusFourHundred) {
        await axiosInstance.post('/user-logout').catch(() => {
          for (const token of ['CVAccessToken', 'CVIdToken']) {
            try {
              Cookies.remove(token);
            } catch (err) {
              console.error('unable to delete cookies', err);
            }
          }
        });
        window.location.href = process.env.BASE_URL + '/purchase';
      }
    });

const fetchAndSaveToken = async () => {
  await fetchAuthToken();
  return getCvAccessToken();
};

export const refreshTokenIfMissing = async () => {
  const { cvIdToken, cvAccessToken, isValidToken } = accessToken();

  if (cvIdToken && !cvAccessToken && !isValidToken) {
    await fetchAndSaveToken();
  }
};

axiosInstance.interceptors.request.use(
  async config => {
    const originalConfig = { ...config };
    originalConfig.headers['correlation-id'] = uuid();
    const token = accessToken();
    let access_token = token.cvAccessToken;

    if (access_token)
      originalConfig.headers.Authorization = `Bearer ${access_token}`;

    if (
      originalConfig.method === 'get' &&
      /MSIE \d|Trident.*rv:/.test(navigator.userAgent)
    ) {
      // add a random query param to remove caching on ie11
      originalConfig.url += `?${new Date().getTime()}`;
    }

    return originalConfig;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  async response => response,
  async error => {
    const { response: { status = null } = {} } = error;

    const originalRequest = error.config;
    if (
      originalRequest.url === tokenRefreshUrl
    ) {
      return Promise.reject(error);
    }

    if (status === 401) {
      if (originalRequest.isRetry) {
        window.location.href = process.env.BASE_URL + '/purchase';
      } else {
        originalRequest.isRetry = true;
        const access_token = await fetchAndSaveToken();

        if (access_token) {
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return axiosInstance(originalRequest);
        }
      }
    }

    return Promise.reject(error);
  }
);

axiosInstance.postWithDomainModel = (url, data, domainModel, opts) =>
  axios.post(url, data, {
    headers: {
      'Content-Type': `application/json; domain-model=${domainModel}; version=1.0.0.0`
    },
    ...opts
  });

export default axiosInstance;
